<template>
    <button
        type="button"
        class="btn btn-pdv btn-pdv-orange mr-1"
        href="javascript: void(0);"
        :disabled="disabled"
        @click="$emit('onClick')"
    >
        <i class="fe-repeat mr-1"></i>
        {{ title }}
    </button>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
    },
}
</script>
